import React, { Component, useEffect, useState } from 'react';
import OrderStoresView from './OrderStoresView'
import crmservices from '../../wsclient/';
import {setOrderCache,order_key,getOrderCache} from '../../utils/order_cache';
import Loading from '../../components/Loading';
import ModalAlert from '../../components/ModalAlert';
import t from '../../utils/translateUtil';
function OrderDirectSaleStoresController(props) {
    const [currentLocation, setCurrentLocation] = useState(props.currentLocation);
    const [showLoading, onShowLoading] = useState(false);
    const [initialRegion, setInitRegion] = useState({
        lat: 35.157322,
        lng: 33.313751
    });
    const [message, setMessage] = useState({})
    const supp_method = props.supp_method? props.supp_method : getOrderCache(order_key.order_type, true);

    const showMessage = (status, message) =>{
        onShowLoading(false);
        setMessage({
            show: status,
            content: message ? message : null
        })
    }
    
    const getRegion = (location) =>{
        if (location && location.lat && location.lon) {
            var region = {
                lat: Number(location.lat),
                lng: Number(location.lon)
            }
            setInitRegion(region);
        }
    }

    const onSelectMerchant = (store) =>{
        getRegion(store.address);
        setOrderCache(order_key.pick_up_store,store);
        if(props.onReloadMenuItems){
            props.onReloadMenuItems();
        }
        if(props.onInitOrderDirectSale){
            props.onInitOrderDirectSale(supp_method, 'open_menu')
        }
        props.onClose();
    }
    return (
        <div>
            
            <OrderStoresView
                open={props.open}
                onClose={props.onClose}
                initialRegion={initialRegion}
                stores={props.stores}
                onSelectMerchant={onSelectMerchant}
                showLoading={showLoading}
            />
            {message && <ModalAlert
                open={message.show}
                onClose={showMessage}
                message={message.content}
            />}  
        </div>
    );
}
export default OrderDirectSaleStoresController;